import PropTypes from 'prop-types'
import React from 'react'
import Loader from 'components/Loader'
import { InView } from 'react-intersection-observer'
import styled from 'styled-components'

const Point = styled.div`
  position: relative;
  height: 400px;
  margin-top: -400px;
  z-index: -99999;
`

export const DefaultLoaderComponent = (props) => {
  return (
    <Loader center {...props} />
  )
}

export class InfiniteScroll extends React.PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    initialLoad: PropTypes.bool.isRequired,
    loaderComponent: PropTypes.func,
  }

  static defaultProps = {
    initialLoad: true,
    loaderComponent: DefaultLoaderComponent,
  }

  state = {
    initialLoad:
      this.props.initialLoad
        ? this.props.isLoaded || !!this.props.children
        : true
  }

  componentDidMount () {
    this.tryLoadMore()
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      !this.state.initialLoad
    ) {
      if (
        (
          prevProps.isLoading &&
          !this.props.isLoading
        ) ||
        this.props.isLoaded
      ) {
        this.setState({
          initialLoad: true
        })
      } else {
        this.tryLoadMore()
      }
    }
  }

  tryLoadMore = () => {
    const {
      isLoading,
      isLoaded,
      onLoadMore
    } = this.props

    if (!isLoading && !isLoaded) {
      onLoadMore()
    }
  }

  render () {
    const {
      children,

      isLoaded,
      isLoading,
      loaderComponent: LoaderComponent,
    } = this.props
    const {
      initialLoad
    } = this.state

    return (
      <React.Fragment>
        {children}
        {isLoading && <LoaderComponent />}
        {(!isLoaded && initialLoad) &&
          <InView
            key={isLoading}
            onChange={(inView, entry) => {
              if (inView) {
                this.tryLoadMore()
              }
            }}
          >
            <Point />
          </InView>
        }
      </React.Fragment>
    )
  }
}

export default InfiniteScroll
